var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 8,
    fill: "#828282"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5124 20.4978C16.418 18.0399 20.3559 16.4195 22.3263 15.6366C27.9521 13.4013 29.1211 13.013 29.883 13.0001C30.0506 12.9973 30.4253 13.037 30.668 13.2251C30.873 13.384 30.9294 13.5986 30.9563 13.7492C30.9833 13.8998 31.0169 14.2429 30.9902 14.511C30.6854 17.571 29.3662 24.9968 28.6951 28.424C28.4111 29.8742 27.852 30.3605 27.3107 30.408C26.1343 30.5114 25.2409 29.6654 24.1015 28.9519C22.3186 27.8354 21.3113 27.1404 19.5807 26.0509C17.5806 24.7918 18.8772 24.0998 20.017 22.9689C20.3153 22.6729 25.4986 18.1691 25.5989 17.7606C25.6115 17.7095 25.6231 17.519 25.5047 17.4184C25.3862 17.3179 25.2114 17.3523 25.0852 17.3796C24.9064 17.4184 22.0581 19.2168 16.5404 22.7749C15.7319 23.3052 14.9996 23.5636 14.3435 23.5501C13.6202 23.5351 12.2288 23.1594 11.1945 22.8382C9.92583 22.4442 8.91753 22.236 9.00533 21.5669C9.05106 21.2184 9.55341 20.8621 10.5124 20.4978Z",
    fill: "#262627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBlack);
export default __webpack_public_path__ + "static/media/telegramBlack.353605a31ef0a7997a74a4b52b24acf8.svg";
export { ForwardRef as ReactComponent };